import { HtmlBridge } from "../../parser/bridges/htmlBridge";
import { Prototype } from "../../parser/prototype/prototypeCreator";
import { ViewModel } from "./viewmodel";

export abstract class View<T extends ViewModel>{
    public onRenderCompleted(): any {
    }
    public onDataContextSet():any{
    }

    public get viewObjectId() : number {return this._viewObjectId;}private _viewObjectId : number;
    public set firstlevelElement(v: Element) { this._firstlevelElement = v; } public get firstlevelElement(): Element { return this._firstlevelElement;} private _firstlevelElement: Element;
    public set dataContext(v: T) { this._dataContext = v; this.onDataContextSet(); } public get dataContext(): T { return this._dataContext;} private _dataContext: T;

    public htmlBridges:HtmlBridge[];

    constructor() {
        this.firstlevelElement = null;
        this.htmlBridges = [];
    }

    abstract GetViewUniqueId():string;
    abstract loadHtml():string;
    childrenSubtreeChanged():boolean{
        return true;
    }
}

export class RawView<T extends ViewModel> extends View<T>{
    GetViewUniqueId(): string {
        return null;
    }
    loadHtml(): string {
        return '';
    }

}